"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IssuesApi = exports.IssueFieldsApi = void 0;
const tslib_1 = require("tslib");
/* tslint:disable */
/* eslint-disable */
tslib_1.__exportStar(require("./AnnouncementBannerApi"), exports);
tslib_1.__exportStar(require("./AppDataPoliciesEAPApi"), exports);
tslib_1.__exportStar(require("./AppMigrationApi"), exports);
tslib_1.__exportStar(require("./AppPropertiesApi"), exports);
tslib_1.__exportStar(require("./ApplicationRolesApi"), exports);
tslib_1.__exportStar(require("./AuditRecordsApi"), exports);
tslib_1.__exportStar(require("./AvatarsApi"), exports);
tslib_1.__exportStar(require("./ClassificationLevelsApi"), exports);
tslib_1.__exportStar(require("./DashboardsApi"), exports);
tslib_1.__exportStar(require("./DynamicModulesApi"), exports);
tslib_1.__exportStar(require("./FilterSharingApi"), exports);
tslib_1.__exportStar(require("./FiltersApi"), exports);
tslib_1.__exportStar(require("./GroupAndUserPickerApi"), exports);
tslib_1.__exportStar(require("./GroupsApi"), exports);
tslib_1.__exportStar(require("./IssueAttachmentsApi"), exports);
tslib_1.__exportStar(require("./IssueCommentPropertiesApi"), exports);
tslib_1.__exportStar(require("./IssueCommentsApi"), exports);
tslib_1.__exportStar(require("./IssueCustomFieldConfigurationAppsApi"), exports);
tslib_1.__exportStar(require("./IssueCustomFieldContextsApi"), exports);
tslib_1.__exportStar(require("./IssueCustomFieldOptionsApi"), exports);
tslib_1.__exportStar(require("./IssueCustomFieldOptionsAppsApi"), exports);
tslib_1.__exportStar(require("./IssueCustomFieldValuesAppsApi"), exports);
tslib_1.__exportStar(require("./IssueFieldConfigurationsApi"), exports);
var IssueFieldsApi_1 = require("./IssueFieldsApi");
Object.defineProperty(exports, "IssueFieldsApi", { enumerable: true, get: function () { return IssueFieldsApi_1.IssueFieldsApi; } });
tslib_1.__exportStar(require("./IssueLinkTypesApi"), exports);
tslib_1.__exportStar(require("./IssueLinksApi"), exports);
tslib_1.__exportStar(require("./IssueNavigatorSettingsApi"), exports);
tslib_1.__exportStar(require("./IssueNotificationSchemesApi"), exports);
tslib_1.__exportStar(require("./IssuePrioritiesApi"), exports);
tslib_1.__exportStar(require("./IssuePropertiesApi"), exports);
tslib_1.__exportStar(require("./IssueRemoteLinksApi"), exports);
tslib_1.__exportStar(require("./IssueResolutionsApi"), exports);
tslib_1.__exportStar(require("./IssueSearchApi"), exports);
tslib_1.__exportStar(require("./IssueSecurityLevelApi"), exports);
tslib_1.__exportStar(require("./IssueSecuritySchemesApi"), exports);
tslib_1.__exportStar(require("./IssueTypePropertiesApi"), exports);
tslib_1.__exportStar(require("./IssueTypeSchemesApi"), exports);
tslib_1.__exportStar(require("./IssueTypeScreenSchemesApi"), exports);
tslib_1.__exportStar(require("./IssueTypesApi"), exports);
tslib_1.__exportStar(require("./IssueVotesApi"), exports);
tslib_1.__exportStar(require("./IssueWatchersApi"), exports);
tslib_1.__exportStar(require("./IssueWorklogPropertiesApi"), exports);
tslib_1.__exportStar(require("./IssueWorklogsApi"), exports);
var IssuesApi_1 = require("./IssuesApi");
Object.defineProperty(exports, "IssuesApi", { enumerable: true, get: function () { return IssuesApi_1.IssuesApi; } });
tslib_1.__exportStar(require("./JQLApi"), exports);
tslib_1.__exportStar(require("./JQLFunctionsAppsApi"), exports);
tslib_1.__exportStar(require("./JiraExpressionsApi"), exports);
tslib_1.__exportStar(require("./JiraSettingsApi"), exports);
tslib_1.__exportStar(require("./LabelsApi"), exports);
tslib_1.__exportStar(require("./LicenseMetricsApi"), exports);
tslib_1.__exportStar(require("./MyselfApi"), exports);
tslib_1.__exportStar(require("./PermissionSchemesApi"), exports);
tslib_1.__exportStar(require("./PermissionsApi"), exports);
tslib_1.__exportStar(require("./ProjectAvatarsApi"), exports);
tslib_1.__exportStar(require("./ProjectCategoriesApi"), exports);
tslib_1.__exportStar(require("./ProjectClassificationLevelsApi"), exports);
tslib_1.__exportStar(require("./ProjectComponentsApi"), exports);
tslib_1.__exportStar(require("./ProjectEmailApi"), exports);
tslib_1.__exportStar(require("./ProjectFeaturesApi"), exports);
tslib_1.__exportStar(require("./ProjectKeyAndNameValidationApi"), exports);
tslib_1.__exportStar(require("./ProjectPermissionSchemesApi"), exports);
tslib_1.__exportStar(require("./ProjectPropertiesApi"), exports);
tslib_1.__exportStar(require("./ProjectRoleActorsApi"), exports);
tslib_1.__exportStar(require("./ProjectRolesApi"), exports);
tslib_1.__exportStar(require("./ProjectTypesApi"), exports);
tslib_1.__exportStar(require("./ProjectVersionsApi"), exports);
tslib_1.__exportStar(require("./ProjectsApi"), exports);
tslib_1.__exportStar(require("./ScreenSchemesApi"), exports);
tslib_1.__exportStar(require("./ScreenTabFieldsApi"), exports);
tslib_1.__exportStar(require("./ScreenTabsApi"), exports);
tslib_1.__exportStar(require("./ScreensApi"), exports);
tslib_1.__exportStar(require("./ServerInfoApi"), exports);
tslib_1.__exportStar(require("./ServiceRegistryApi"), exports);
tslib_1.__exportStar(require("./StatusApi"), exports);
tslib_1.__exportStar(require("./TasksApi"), exports);
tslib_1.__exportStar(require("./TimeTrackingApi"), exports);
tslib_1.__exportStar(require("./UIModificationsAppsApi"), exports);
tslib_1.__exportStar(require("./UserPropertiesApi"), exports);
tslib_1.__exportStar(require("./UserSearchApi"), exports);
tslib_1.__exportStar(require("./UsersApi"), exports);
tslib_1.__exportStar(require("./WebhooksApi"), exports);
tslib_1.__exportStar(require("./WorkflowSchemeDraftsApi"), exports);
tslib_1.__exportStar(require("./WorkflowSchemeProjectAssociationsApi"), exports);
tslib_1.__exportStar(require("./WorkflowSchemesApi"), exports);
tslib_1.__exportStar(require("./WorkflowStatusCategoriesApi"), exports);
tslib_1.__exportStar(require("./WorkflowStatusesApi"), exports);
tslib_1.__exportStar(require("./WorkflowTransitionPropertiesApi"), exports);
tslib_1.__exportStar(require("./WorkflowTransitionRulesApi"), exports);
tslib_1.__exportStar(require("./WorkflowsApi"), exports);
//# sourceMappingURL=index.js.map